module.exports = __webpack_public_path__ + "media/components/src/assets/images/text_type_1-4ab86c59a9eec8bd431169ed0ed41010.jpg";